import Router from 'next/router';
import GTM from 'react-gtm-module';
import {
  KEY_ORDER_INFO,
  setItemSessionStorage,
} from '../../variables/Variables';
import { config } from '_config';
import { createLeadEventBody } from '_helpers/analytics';
import { sanitizeFileName } from '_helpers/utils';
import { restoreLocalValue, restoreSessionValue } from '_helpers/storage';

const { apiUrl } = config;

export const customer = (orderInfo) => {
  const customerValue = {
    email: orderInfo.email,
    phone: orderInfo.phone ? orderInfo.phone.replace(/\D/g, '') : null,
    firstName: orderInfo.firstName,
    lastName: orderInfo.lastName,
  };
  if (orderInfo.consentToGetSMS === true) {
    customerValue.consentToGetSMS = true;
  }
  if (orderInfo.address) {
    customerValue.billingAddress = address(orderInfo, '');
  }
  if (localStorage && localStorage.getItem('requestUri')) {
    customerValue.firstCLickURL = localStorage.getItem('requestUri');
  }
  return customerValue;
};
export const address = (orderInfo, addressId) => {
  return {
    address1: orderInfo[addressId + 'address'],
    city: orderInfo[addressId + 'city'],
    state: orderInfo[addressId + 'state'],
    zip: orderInfo[addressId + 'zip'],
    country: 'US',
  };
};
export const date = (orderInfo, dateId) => {
  if (!orderInfo[dateId + 'Year'] && orderInfo[dateId + 'Year'].length === 0)
    return null;
  const year = parseInt(orderInfo[dateId + 'Year']);
  const month = parseInt(orderInfo[dateId + 'Month']) - 1; // to start from 0
  const day = parseInt(orderInfo[dateId + 'Day']);
  if (!Number.isNaN(new Date(year, month, day, 10, 0, 0).getTime())) {
    return new Date(year, month, day, 10, 0, 0).toISOString().split('T')[0];
  }
  return null;
};

export const nameInMark = (productTrademark, orderInfo) => {
  if (orderInfo.isIncludeLivingPersonName === 'true') {
    if (orderInfo.isIncludeNicknameName === 'false') {
      if (orderInfo.isOtherLivingName === 'false') {
        productTrademark.includedName = 'OTHER_NAME';
      } else {
        productTrademark.includedName = 'OTHER_LIVING_NAME';
        productTrademark.includedNameValue = orderInfo.otherLivingName;
      }
    } else {
      productTrademark.includedName = 'OWNER_NAME';
      productTrademark.includedNameValue = orderInfo.ownName;
    }
  } else {
    productTrademark.includedName = 'NONE';
  }
};
export const translationWords = (productTrademark, orderInfo) => {
  if (orderInfo.includeTranslationWords === 'false') {
    productTrademark.includeTranslationWords = false;
  } else {
    productTrademark.includeTranslationWords = true;
    productTrademark.translation = orderInfo.translation;
  }
};
export const currentTrademark = (productTrademark, orderInfo) => {
  if (orderInfo.currentTrademark === 'false') {
    productTrademark.currentTrademark = false;
  } else {
    productTrademark.currentTrademark = true;
    if (orderInfo.firstUseInCommerceYear)
      productTrademark.firstUseInCommerce = date(
        orderInfo,
        'firstUseInCommerce'
      );
    if (orderInfo.firstUseAnywhereYear)
      productTrademark.firstUseAnywhere = date(orderInfo, 'firstUseAnywhere');
  }
};
export const trademarkRegistrationPreOrder = (
  orderInfo,
  imageLogo,
  stepsLength,
  isProcessing
) => {
  return (dispatch) => {
    let products;
    if (orderInfo.step > 0) {
      if (
        orderInfo.markDesc !== null &&
        orderInfo.markDesc.length > 0 &&
        orderInfo.firstName !== null &&
        orderInfo.lastName !== null &&
        orderInfo.email !== null &&
        orderInfo.phone !== null &&
        orderInfo.phone.length > 0
      ) {
        const productTrademark = {
          code: orderInfo.registerTrademarkType,
          trademarkType: orderInfo.trademarkType,
          markDesc: orderInfo.markDesc,
        };
        if (orderInfo.trademarkType === 'LOGO') {
          productTrademark.literalElements = orderInfo.literalElements;
          productTrademark.logoColoredVariety =
            orderInfo.logoColoredVariety === 'false' ? false : true;
          if (orderInfo.logoColoredVariety === 'false') {
            productTrademark.colorsInLogo = orderInfo.colorsInLogo;
          }
        }
        nameInMark(productTrademark, orderInfo);
        translationWords(productTrademark, orderInfo);
        currentTrademark(productTrademark, orderInfo);
        productTrademark.individual = {
          firstName: orderInfo.firstName,
          lastName: orderInfo.lastName,
          countryOfCitizenship: orderInfo.countryOfCitizenship,
          email: orderInfo.email,
          phone: orderInfo.phone ? orderInfo.phone.replace(/\D/g, '') : null,
          address: address(orderInfo, ''),
        };
        if (orderInfo.individualOrgOrInd === 'Organization') {
          productTrademark.organization = {
            usBased: orderInfo.isNonUsBased === 'USBased' ? true : false,
            name: orderInfo.orgName,
            type: orderInfo.orgType,
            stateOrCountryOfFormation:
              orderInfo.isNonUsBased === 'USBased'
                ? orderInfo.orgState
                : orderInfo.formationCountry,
            position: orderInfo.orgPosition,
          };
        }
        if (orderInfo.individualOrgOrInd === 'Individual') {
          if (orderInfo.coOwners) {
            let coOwners = [];
            orderInfo.coOwners.forEach((coOwner) => {
              coOwners.push({
                firstName: coOwner.firstName,
                lastName: coOwner.lastName,
                email: coOwner.email,
                phone: coOwner.phone ? coOwner.phone.replace(/\D/g, '') : null,
                address: address(coOwner, ''),
              });
            });
            productTrademark.coOwners = coOwners;
          }
        }
        if (orderInfo.step > 1) {
          productTrademark.classes = orderInfo.classes;
        }
        products = [productTrademark];
        if (
          orderInfo.step > 2 ||
          (orderInfo.option && orderInfo.option !== 'STANDARD')
        ) {
          const productSearch = {
            code: orderInfo.searchType,
            searchTermType: orderInfo.trademarkType,
            text: orderInfo.markDesc,
          };
          const productTrademarkMonitoring = {
            code: 'TRADEMARK_Trademark_Monitoring',
            trademarkName: orderInfo.markDesc,
          };
          const officeActionResponse = {
            code: 'TRADEMARK_Trademark_Office_Action_Response',
            trademarkName: orderInfo.markDesc,
          };
          officeActionResponse.trademarkOwner = {
            firstName: orderInfo.firstName,
            lastName: orderInfo.lastName,
            email: orderInfo.email,
            phone: orderInfo.phone ? orderInfo.phone.replace(/\D/g, '') : null,
          };
          products = [
            productTrademark,
            productSearch,
            productTrademarkMonitoring,
          ];
          if (orderInfo.option === 'PREMIER') {
            products.push(officeActionResponse);
          }
          if (
            orderInfo.step > 3 ||
            (orderInfo.step === stepsLength && orderInfo.step === 3)
          ) {
            if (isProcessing) {
              if (
                orderInfo.rushProcessing !== 'TRADEMARK_Standard_Processing'
              ) {
                const rushProduct = {
                  code: orderInfo.rushProcessing,
                  processingOption: orderInfo.option,
                };
                if (orderInfo.rushProcessing) {
                  products.push(rushProduct);
                }
              }
            } else {
              const rushProduct = {
                code: orderInfo.trademarkRushType,
                processingOption: 'STANDARD',
              };
              if (orderInfo.rushProcessing) {
                products.push(rushProduct);
              }
            }
          }
        }
        const order = {
          products: products,
          customer: customer(orderInfo),
        };
        order.order
          ? (order.order = {
              ...order.order,
              device: orderInfo.device,
              processingOption: orderInfo.option,
            })
          : (order.order = {
              device: orderInfo.device,
              processingOption: orderInfo.option,
            });
        if (orderInfo.campaignId) {
          order.order.campaignId = orderInfo.campaignId;
        }
        dispatch(
          preOrderCreate(
            order,
            orderInfo.lead,
            orderInfo.step,
            orderInfo.trademarkType === 'LOGO' ? imageLogo : null,
            stepsLength
          )
        );
      } else {
        localStorage.removeItem('path');
        localStorage.removeItem('product');
        localStorage.removeItem('token');
        localStorage.removeItem('tokenDiscount');
        localStorage.removeItem('updated');
        Router.push(Router.pathname + '?step=0').then();
      }
    }
  };
};
export const comprehensiveSearchOrder = (orderInfo) => {
  return (dispatch) => {
    const productSearch = {
      code: orderInfo.searchType,
      searchTermType: orderInfo.trademarkType,
      text: orderInfo.markDesc,
    };
    if (orderInfo.trademarkType === 'LOGO') {
      productSearch.logoWords = orderInfo.literalElements;
    }
    const rushProduct = {
      code: orderInfo.trademarkRushType,
      processingOption: 'STANDARD',
    };
    const order = {
      products: orderInfo.rushProcessing
        ? [productSearch, rushProduct]
        : [productSearch],
      customer: customer(orderInfo),
    };
    order.order
      ? (order.order = {
          ...order.order,
          device: orderInfo.device,
          processingOption: 'STANDARD',
        })
      : (order.order = {
          device: orderInfo.device,
          processingOption: 'STANDARD',
        });

    dispatch(orderCreate(order, false, null));
  };
};

export const officeActionResponseOrder = (orderInfo) => {
  return (dispatch) => {
    const productStatement = {
      code: orderInfo.code,
    };
    if (orderInfo.serialProvided === 'true') {
      productStatement.serialNumber = orderInfo.serialNumber;
    } else {
      productStatement.trademarkName = orderInfo.markDesc;
      productStatement.trademarkOwner = {
        firstName: orderInfo.markOwnerFirstName,
        lastName: orderInfo.markOwnerLastName,
        email: orderInfo.markOwnerEmail,
        phone: orderInfo.markOwnerPhone
          ? orderInfo.markOwnerPhone.replace(/\D/g, '')
          : null,
      };
    }
    if (orderInfo.changeAddress === 'true') {
      productStatement.newAddress = address(orderInfo, 'new');
    }
    if (orderInfo.needsSpecimen === 'yes') {
      productStatement.newSpecimenWasUploaded = true;
    }
    if (orderInfo.changeMarkOwner === 'true') {
      productStatement.changesToOwner = {
        firstName: orderInfo.changeMarkOwnerFirstName,
        lastName: orderInfo.changeMarkOwnerLastName,
      };
    }

    const rushProduct = {
      code: orderInfo.trademarkRushType,
      processingOption: 'STANDARD',
    };
    const order = {
      products: orderInfo.rushProcessing
        ? [productStatement, rushProduct]
        : [productStatement],
      customer: customer(orderInfo),
    };
    order.order
      ? (order.order = {
          ...order.order,
          device: orderInfo.device,
          processingOption: 'STANDARD',
        })
      : (order.order = {
          device: orderInfo.device,
          processingOption: 'STANDARD',
        });

    dispatch(orderCreate(order, false, null));
  };
};
export const renewalOrder = (orderInfo, imageSpecimen) => {
  return (dispatch) => {
    const productRenewal = {
      code: orderInfo.code,
    };
    if (orderInfo.serialProvided === 'true') {
      productRenewal.serialNumber = orderInfo.serialNumber;
    } else {
      productRenewal.trademarkName = orderInfo.markDesc;
      productRenewal.trademarkOwner = {
        firstName: orderInfo.markOwnerFirstName,
        lastName: orderInfo.markOwnerLastName,
        email: orderInfo.markOwnerEmail,
        phone: orderInfo.markOwnerPhone
          ? orderInfo.markOwnerPhone.replace(/\D/g, '')
          : null,
      };
    }
    productRenewal.inUseStatus = orderInfo.inUseStatus;
    if (orderInfo.inUseStatus === 'YES_ON_SOME') {
      productRenewal.goodsAndServicesStillInUse =
        orderInfo.goodsAndServicesStillInUse;
      productRenewal.goodsAndServicesNoLongerInUse =
        orderInfo.goodsAndServicesNoLongerInUse;
    }
    if (orderInfo.isNewAddress === 'false') {
      productRenewal.newAddress = address(orderInfo, 'new');
    }
    if (orderInfo.isNewName === 'false') {
      productRenewal.newFirstName = orderInfo.newFirstName;
      productRenewal.newLastName = orderInfo.newLastName;
    }
    if (orderInfo.specimen === 'false') {
      productRenewal.websiteURL = orderInfo.specimenURL;
    }
    const rushProduct = {
      code: orderInfo.trademarkRushType,
      processingOption: 'STANDARD',
    };
    const order = {
      products: orderInfo.rushProcessing
        ? [productRenewal, rushProduct]
        : [productRenewal],
      customer: customer(orderInfo),
    };

    order.order
      ? (order.order = {
          ...order.order,
          device: orderInfo.device,
          processingOption: 'STANDARD',
        })
      : (order.order = {
          device: orderInfo.device,
          processingOption: 'STANDARD',
        });

    dispatch(
      orderCreate(
        order,
        false,
        orderInfo.specimen === 'true' ? imageSpecimen : null
      )
    );
  };
};
export const reviveOrder = (orderInfo) => {
  return (dispatch) => {
    const productRevive = {
      code: orderInfo.code,
      officeActionStatus: orderInfo.officeActionStatus,
      statementOfUseStatus: orderInfo.statementOfUseStatus,
    };
    if (orderInfo.serialProvided === 'true') {
      productRevive.serialNumber = orderInfo.serialNumber;
    } else {
      productRevive.trademarkName = orderInfo.markDesc;
      productRevive.trademarkOwner = {
        firstName: orderInfo.markOwnerFirstName,
        lastName: orderInfo.markOwnerLastName,
        email: orderInfo.markOwnerEmail,
        phone: orderInfo.markOwnerPhone
          ? orderInfo.markOwnerPhone.replace(/\D/g, '')
          : null,
      };
    }
    const rushProduct = {
      code: orderInfo.trademarkRushType,
      processingOption: 'STANDARD',
    };
    const order = {
      products: orderInfo.rushProcessing
        ? [productRevive, rushProduct]
        : [productRevive],
      customer: customer(orderInfo),
    };
    order.order
      ? (order.order = {
          ...order.order,
          device: orderInfo.device,
          processingOption: 'STANDARD',
        })
      : (order.order = {
          device: orderInfo.device,
          processingOption: 'STANDARD',
        });

    dispatch(orderCreate(order, false, null));
  };
};
export const statementOfUseOrder = (orderInfo, imageSpecimen) => {
  return (dispatch) => {
    const productStatement = {
      code: orderInfo.code,
    };
    if (orderInfo.serialProvided === 'true') {
      productStatement.serialNumber = orderInfo.serialNumber;
    } else {
      productStatement.trademarkName = orderInfo.markDesc;
      productStatement.trademarkOwner = {
        firstName: orderInfo.markOwnerFirstName,
        lastName: orderInfo.markOwnerLastName,
        email: orderInfo.markOwnerEmail,
        phone: orderInfo.markOwnerPhone
          ? orderInfo.markOwnerPhone.replace(/\D/g, '')
          : null,
      };
    }
    if (orderInfo.changeAddress === 'true') {
      productStatement.newAddress = address(orderInfo, 'new');
    }
    if (orderInfo.noticeOfAllowance === 'false') {
      productStatement.classesOrGoodsNotIncludedInAllegation =
        orderInfo.classesGoodsNotCovered;
      if (orderInfo.extensionOnOthers === 'true') {
        productStatement.itemsCoveredByThisStatement = orderInfo.itemsCovered;
        productStatement.itemsCoveredByThisExtensionRequest =
          orderInfo.itemsExtension;
      }
    }
    if (orderInfo.firstUseInCommerceYear)
      productStatement.firstUseInCommerce = date(
        orderInfo,
        'firstUseInCommerce'
      );
    if (orderInfo.firstUseAnywhereYear)
      productStatement.firstUseAnywhere = date(orderInfo, 'firstUseAnywhere');
    if (orderInfo.noticeOfAllowance === 'true') {
      productStatement.coversAllGoods = true;
      productStatement.specimenClass = orderInfo.goodsOrService;
    } else {
      productStatement.coversAllGoods = false;
    }
    if (orderInfo.changeMarkOwner === 'true') {
      productStatement.changesToOwner = {
        firstName: orderInfo.changeMarkOwnerFirstName,
        lastName: orderInfo.changeMarkOwnerLastName,
      };
    }
    //   private String changesToDrawing;
    //   private String changesToTrademarkName;
    //   private boolean newSpecimenWasUploaded;
    if (orderInfo.specimen === 'false') {
      productStatement.websiteURL = orderInfo.specimenURL;
    }
    const rushProduct = {
      code: orderInfo.trademarkRushType,
      processingOption: 'STANDARD',
    };
    const order = {
      products: orderInfo.rushProcessing
        ? [productStatement, rushProduct]
        : [productStatement],
      customer: customer(orderInfo),
    };
    order.order
      ? (order.order = {
          ...order.order,
          device: orderInfo.device,
          processingOption: 'STANDARD',
        })
      : (order.order = {
          device: orderInfo.device,
          processingOption: 'STANDARD',
        });

    dispatch(
      orderCreate(
        order,
        false,
        orderInfo.specimen === 'true' ? imageSpecimen : null
      )
    );
  };
};
export const trademarkMonitoringOrder = (orderInfo) => {
  return (dispatch) => {
    const productTrademarkMonitoring = {
      code: orderInfo.code,
      trademarkName: orderInfo.trademarkName,
    };
    productTrademarkMonitoring.owner = {
      firstName: orderInfo.firstName,
      lastName: orderInfo.lastName,
      email: orderInfo.email,
      phone: orderInfo.phone ? orderInfo.phone.replace(/\D/g, '') : null,
    };

    const order = {
      products: [productTrademarkMonitoring],
      customer: customer(orderInfo),
    };
    order.order
      ? (order.order = {
          ...order.order,
          device: orderInfo.device,
          processingOption: 'STANDARD',
        })
      : (order.order = {
          device: orderInfo.device,
          processingOption: 'STANDARD',
        });

    dispatch(orderCreate(order, false, null));
  };
};
export const logoDesignServiceOrder = (orderInfo) => {
  return (dispatch) => {
    let productLogoDesignService = JSON.parse(JSON.stringify(orderInfo));
    if (orderInfo.step > 0) {
      if (
        orderInfo.firstName !== null &&
        orderInfo.firstName.trim().length > 0 &&
        orderInfo.lastName !== null &&
        orderInfo.lastName.trim().length > 0 &&
        orderInfo.email !== null &&
        orderInfo.email.trim().length > 0 &&
        orderInfo.phone !== null &&
        orderInfo.phone.trim().length > 0
      ) {
        delete productLogoDesignService.verificationResult;
        delete productLogoDesignService.verifying;
        delete productLogoDesignService.step;
        delete productLogoDesignService.option;
        delete productLogoDesignService.device;
        const order = {
          products: [productLogoDesignService],
          customer: customer(orderInfo),
        };
        order.order
          ? (order.order = {
              ...order.order,
              device: orderInfo.device,
              processingOption: orderInfo.option,
            })
          : (order.order = {
              device: orderInfo.device,
              processingOption: orderInfo.option,
            });
        dispatch(orderCreate(order, false, null));
      } else {
        localStorage.removeItem('path');
        localStorage.removeItem('product');
        localStorage.removeItem('token');
        localStorage.removeItem('tokenDiscount');
        localStorage.removeItem('updated');
        Router.push('/logo-design-service-report?step=0').then();
      }
    }
  };
};
export const preOrderCreate = (order, isLead, step, imageLogo, stepLength) => {
  const firstClickURL = restoreLocalValue('firstClickURL');
  const saleURL = restoreSessionValue('saleURL') || firstClickURL || null;
  if (saleURL) {
    order.order ? (order.order.saleURL = saleURL) : (order.order = { saleURL });
  }
  if (firstClickURL) {
    order.order ? (order.order.firstClickURL = firstClickURL) : (order.order = { firstClickURL });
  }
  const fingerprint = restoreLocalValue('fingerprint');
  if (fingerprint) {
    order.order ? (order.order.fingerprint = fingerprint) : (order.order = { fingerprint });
  }

  if (localStorage.getItem('gclid')) {
    order.order
      ? (order.order.clid = localStorage.getItem('gclid'))
      : (order.order = { clid: localStorage.getItem('gclid') });
  }

  if (localStorage.getItem('source')) {
    order.order
      ? (order.order.source = localStorage.getItem('source'))
      : (order.order = { source: localStorage.getItem('source') });
  }

  if (localStorage.getItem('keyword')) {
    order.order
      ? (order.order.keyword = localStorage.getItem('keyword'))
      : (order.order = { keyword: localStorage.getItem('keyword') });
  }

  if (localStorage.getItem('adAccount')) {
    order.order
      ? (order.order.adAccount = localStorage.getItem('adAccount'))
      : (order.order = { adAccount: localStorage.getItem('adAccount') });
  }

  let salePage = window.location.href;
  let salePageURLArr = salePage.split('/');
  let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
    /\/+$/,
    ''
  );

  let url = apiUrl + '/category/products';
  let fallbackUrl = `${salePageURL}/crm` + '/category/products';

  if (localStorage.getItem('crmSessionId')) {
    let crmSessionId = localStorage.getItem('crmSessionId');
    url += '?crmSessionId=' + crmSessionId;
    fallbackUrl += '?crmSessionId=' + crmSessionId;
  }

  order.order
    ? (order.order.salePageURL =
        salePageURL + process.env.NEXT_PUBLIC_BASE_PATH)
    : (order.order = {
        salePageURL: salePageURL + process.env.NEXT_PUBLIC_BASE_PATH,
      });
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  let token = localStorage.getItem('token');
  let method = 'POST';
  if (token) {
    let updated = localStorage.getItem('updated');
    if (updated) {
      order.order.updated = updated;
    }
    token = JSON.parse(token);
    headers['Authorization'] = `Bearer ${token.token}`;
    method = 'PUT';
  }
  return (dispatch) => {
    dispatch(orderStarted());
    return fetch(url, {
      method: method,
      headers: headers,
      body: JSON.stringify(order),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 403) {
            localStorage.removeItem('token');
            localStorage.removeItem('updated');
          }

          (async function () {
            const errorBody = await response.json();

            if (
              errorBody?.code === 400 &&
              errorBody?.message === 'Illegal order status'
            ) {
              localStorage.removeItem('path');
              localStorage.removeItem('product');
              localStorage.removeItem('token');
              localStorage.removeItem('tokenDiscount');
              localStorage.removeItem('updated');
              Router.reload(Router.pathname);
            }
            if (errorBody?.code === 400 || errorBody?.code === 500) {
              dispatch(
                orderFailure({
                  message:
                    'Error: ' +
                    errorBody?.message.replace(/\b\w/g, (c) => c.toUpperCase()),
                })
              );
            }
          })();
        }
        dispatch(orderFailure({ message: 'Error' }));
        throw new Error('Error');
      })
      .then((data) => {
        if (data.token) {
          localStorage.setItem('token', JSON.stringify(data.token));
        }
        if (data.updated) {
          localStorage.setItem('updated', data.updated);
        }
        if (data.order?.updated) {
          localStorage.setItem('updated', data.order.updated);
        }
        let complex = { order: data, product: order };
        let tokenDiscount = localStorage.getItem('tokenDiscount');
        if (tokenDiscount) complex.token = tokenDiscount;
        dispatch(orderSuccess(complex));
        setItemSessionStorage(KEY_ORDER_INFO, complex);
        localStorage.setItem(KEY_ORDER_INFO, JSON.stringify(complex));
        if (step === stepLength) {
          Router.push('/payment').then();
        }
        if (imageLogo && step === 1) {
          const formData = new FormData();
          formData.append('file', imageLogo, sanitizeFileName(imageLogo?.name));

          fetch(
            apiUrl +
              '/orders/' +
              data.id +
              '/products/' +
              data.products[0].id +
              '/result-PDF?fileType=TRADEMARK_LOGO',
            {
              method: 'POST',
              headers: { Authorization: `Bearer ${data.token.token}` },
              body: formData,
            }
          ).then((response) => {
            if (response.ok) {
            }
          });
        }
        if (!isLead) {
          const gtmData = createLeadEventBody(order);
          GTM.dataLayer(gtmData);
        }
      })
      .catch((error) => {
        console.log('error2');
        console.log(error);
        if (error.response) {
          // client received an error response (5xx, 4xx)
          if (error.response.data) {
            dispatch(
              orderFailure({
                message:
                  error.response.data.code + ': ' + error.response.data.message,
              })
            );
          } else {
            dispatch(orderFailure({ message: 'Error' }));
          }
        } else if (error.request) {
          // client never received a response, or request never left
          return fetch(fallbackUrl, {
            method: method,
            headers: headers,
            body: JSON.stringify(order),
          })
            .then((response) => {
              if (response.ok) {
                return response.json();
              } else {
                if (response.status === 403) {
                  localStorage.removeItem('token');
                  localStorage.removeItem('updated');
                }
              }
              dispatch(orderFailure({ message: 'Error' }));
              throw new Error('Error');
            })
            .then((data) => {
              if (data.token) {
                localStorage.setItem('token', JSON.stringify(data.token));
              }
              if (data.updated) {
                localStorage.setItem('updated', data.updated);
              }
              if (data.order?.updated) {
                localStorage.setItem('updated', data.order.updated);
              }
              let complex = { order: data, product: order };
              dispatch(orderSuccess(complex));
              let tokenDiscount = localStorage.getItem('tokenDiscount');
              if (tokenDiscount) complex.token = tokenDiscount;
              dispatch(orderSuccess(complex));
              setItemSessionStorage(KEY_ORDER_INFO, complex);
              localStorage.setItem(KEY_ORDER_INFO, JSON.stringify(complex));
              if (step === stepLength) {
                Router.push('/payment').then();
              }
              if (imageLogo && step === 1) {
                const formData = new FormData();
                formData.append(
                  'file',
                  imageLogo,
                  sanitizeFileName(imageLogo?.name)
                );
                fetch(
                  `${salePageURL}/crm` +
                    '/orders/' +
                    data.id +
                    '/products/' +
                    data.products[0].id +
                    '/result-PDF?fileType=TRADEMARK_LOGO',
                  {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${data.token.token}` },
                    body: formData,
                  }
                ).then((response) => {
                  if (response.ok) {
                  }
                });
              }
              if (!isLead) {
                GTM.dataLayer(createLeadEventBody(order));
              }
            })
            .catch((error) => {
              console.log('error3');
              if (error.response) {
                // client received an error response (5xx, 4xx)
                if (error.response.data) {
                  dispatch(
                    orderFailure({
                      message:
                        error.response.data.code +
                        ': ' +
                        error.response.data.message,
                    })
                  );
                } else {
                  dispatch(orderFailure({ message: 'Error' }));
                }
              } else if (error.request) {
                // client never received a response, or request never left
                dispatch(orderFailure({ message: 'Network Error' }));
              } else {
                dispatch(orderFailure({ message: error.message }));
              }
            });
        } else {
          dispatch(orderFailure({ message: error.message }));
        }
      });
  };
};
export const orderCreate = (order, isLead, file) => {
  const firstClickURL = restoreLocalValue('firstClickURL');
  const saleURL = restoreSessionValue('saleURL') || firstClickURL || null;
  if (saleURL) {
    order.order ? (order.order.saleURL = saleURL) : (order.order = { saleURL });
  }
  if (firstClickURL) {
    order.order ? (order.order.firstClickURL = firstClickURL) : (order.order = { firstClickURL });
  }
  const fingerprint = restoreLocalValue('fingerprint');
  if (fingerprint) {
    order.order ? (order.order.fingerprint = fingerprint) : (order.order = { fingerprint });
  }

  if (localStorage.getItem('gclid')) {
    order.order
      ? (order.order.clid = localStorage.getItem('gclid'))
      : (order.order = { clid: localStorage.getItem('gclid') });
  }

  if (localStorage.getItem('source')) {
    order.order
      ? (order.order.source = localStorage.getItem('source'))
      : (order.order = { source: localStorage.getItem('source') });
  }

  if (localStorage.getItem('keyword')) {
    order.order
      ? (order.order.keyword = localStorage.getItem('keyword'))
      : (order.order = { keyword: localStorage.getItem('keyword') });
  }

  if (localStorage.getItem('adAccount')) {
    order.order
      ? (order.order.adAccount = localStorage.getItem('adAccount'))
      : (order.order = { adAccount: localStorage.getItem('adAccount') });
  }

  let salePage = window.location.href;
  let salePageURLArr = salePage.split('/');
  let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
    /\/+$/,
    ''
  );

  let url = apiUrl + '/category/products';
  let fallbackUrl = `${salePageURL}/crm` + '/category/products';

  if (localStorage.getItem('crmSessionId')) {
    let crmSessionId = localStorage.getItem('crmSessionId');
    url += '?crmSessionId=' + crmSessionId;
    fallbackUrl += '?crmSessionId=' + crmSessionId;
  }

  order.order
    ? (order.order.salePageURL =
        salePageURL + process.env.NEXT_PUBLIC_BASE_PATH)
    : (order.order = {
        salePageURL: salePageURL + process.env.NEXT_PUBLIC_BASE_PATH,
      });

  return (dispatch) => {
    dispatch(orderStarted());
    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(order),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        dispatch(orderFailure({ message: 'Error' }));
        throw new Error('Error');
      })
      .then((data) => {
        let complex = { order: data, product: order };
        setItemSessionStorage(KEY_ORDER_INFO, complex);
        localStorage.setItem(KEY_ORDER_INFO, JSON.stringify(complex));
        dispatch(orderSuccess(complex));
        if (!isLead) {
          GTM.dataLayer(createLeadEventBody(order));
        }
        if (file) {
          const formData = new FormData();
          formData.append('file', file, sanitizeFileName(file?.name));
          fetch(
            apiUrl +
              '/orders/' +
              data.id +
              '/products/' +
              data.products[0].id +
              '/result-PDF?fileType=TRADEMARK_SPECIMEN',
            {
              method: 'POST',
              headers: { Authorization: `Bearer ${data.token.token}` },
              body: formData,
            }
          ).then((response) => {
            if (response.ok) {
            }
          });
        }
        Router.push('/payment').then();
      })
      .catch((error) => {
        console.log('error2');
        if (error.response) {
          // client received an error response (5xx, 4xx)
          if (error.response.data) {
            dispatch(
              orderFailure({
                message:
                  error.response.data.code + ': ' + error.response.data.message,
              })
            );
          } else {
            dispatch(orderFailure({ message: 'Error' }));
          }
        } else if (error.request) {
          // client never received a response, or request never left
          return fetch(fallbackUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(order),
          })
            .then((response) => {
              if (response.ok) {
                return response.json();
              }
              dispatch(orderFailure({ message: 'Error' }));
              throw new Error('Error');
            })
            .then((data) => {
              let complex = { order: data, product: order };
              setItemSessionStorage(KEY_ORDER_INFO, complex);
              localStorage.setItem(KEY_ORDER_INFO, JSON.stringify(complex));
              dispatch(orderSuccess(complex));
              if (!isLead) {
                GTM.dataLayer(createLeadEventBody(order));
              }
              if (file) {
                const formData = new FormData();
                formData.append('file', file, sanitizeFileName(file?.name));
                fetch(
                  `${salePageURL}/crm` +
                    '/orders/' +
                    data.id +
                    '/products/' +
                    data.products[0].id +
                    '/result-PDF?fileType=TRADEMARK_SPECIMEN',
                  {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${data.token.token}` },
                    body: formData,
                  }
                ).then((response) => {
                  if (response.ok) {
                  }
                });
              }
              Router.push('/payment').then();
            })
            .catch((error) => {
              console.log('error2');
              if (error.response) {
                // client received an error response (5xx, 4xx)
                if (error.response.data) {
                  dispatch(
                    orderFailure({
                      message:
                        error.response.data.code +
                        ': ' +
                        error.response.data.message,
                    })
                  );
                } else {
                  dispatch(orderFailure({ message: 'Error' }));
                }
              } else if (error.request) {
                // client never received a response, or request never left
                dispatch(orderFailure({ message: 'Network Error' }));
              } else {
                dispatch(orderFailure({ message: error.message }));
              }
            });
        } else {
          dispatch(orderFailure({ message: error.message }));
        }
      });
  };
};
export const extensionOrder = (orderInfo) => {
  return (dispatch) => {
    const productExtension = {
      code: orderInfo.code,
    };
    if (orderInfo.serialProvided === 'true') {
      productExtension.serialNumber = orderInfo.serialNumber;
    } else {
      productExtension.trademarkName = orderInfo.markDesc;
      productExtension.trademarkOwner = {
        firstName: orderInfo.markOwnerFirstName,
        lastName: orderInfo.markOwnerLastName,
        email: orderInfo.markOwnerEmail,
        phone: orderInfo.markOwnerPhone
          ? orderInfo.markOwnerPhone.replace(/\D/g, '')
          : null,
      };
    }
    if (orderInfo.changeAddress === 'true') {
      productExtension.newAddress = address(orderInfo, 'new');
    }
    if (orderInfo.noticeOfAllowance === 'false') {
      productExtension.missedGoodsOrServices = orderInfo.classesGoodsNotCovered;
    }
    productExtension.timesDeadlineWasExtended =
      orderInfo.numberOfExtensionsFiled;
    // if (orderInfo.noticeOfAllowance === "true") {
    //   productStatement.coversAllGoods = true;
    //   productStatement.specimenClass = orderInfo.goodsOrService;
    // } else {
    //   productStatement.coversAllGoods = false;
    // }
    if (orderInfo.changeMarkOwner === 'true') {
      productExtension.changesToOwner = {
        firstName: orderInfo.changeMarkOwnerFirstName,
        lastName: orderInfo.changeMarkOwnerLastName,
      };
    }
    const rushProduct = {
      code: orderInfo.trademarkRushType,
      processingOption: 'STANDARD',
    };
    const order = {
      products: orderInfo.rushProcessing
        ? [productExtension, rushProduct]
        : [productExtension],
      customer: customer(orderInfo),
    };
    order.order
      ? (order.order = {
          ...order.order,
          device: orderInfo.device,
          processingOption: 'STANDARD',
        })
      : (order.order = {
          device: orderInfo.device,
          processingOption: 'STANDARD',
        });
    dispatch(orderCreate(order, false, null));
  };
};
export const orderStarted = () => ({
  type: 'ORDER_STARTED',
});

export const orderSuccess = (order) => ({
  type: 'ORDER_SUCCESS',
  order: order,
});

export const orderFailure = (error) => ({
  type: 'ORDER_FAILURE',
  error: error,
});

export const clearErrorMessage = () => ({
  type: 'CLEAR_ERROR',
});
